// extracted by mini-css-extract-plugin
export var brand = "_56-9";
export var compact = "_56-6";
export var extraSmall = "_56-7";
export var icon = "_56-0";
export var large = "_56-4";
export var light = "_56-1";
export var medium = "_56-5";
export var outline = "_56-b";
export var primaryDark = "_56-a";
export var primaryLight = "_56-8";
export var primaryModern = "_56-c";
export var success = "_56-2";
export var successSolid = "_56-3";